import React from "react";
import BaseReportPage from "./_BaseReportPage";

const columns = [
  { title: "Date", key: "date" },
  { title: "Code", key: "employee_code" },
  { title: "Name", key: "name" },
  { title: "Location", key: "location" },
  { title: "Outdoor Mins", key: "outdoor_minutes" },
  { title: "Remark", key: "remark" },
];

export default function OutdoorReportPage() {
  return <BaseReportPage columns={columns} title="Outdoor Report" emptyMessage="No outdoor records" />;
}
